module.exports = {
    language: {
        name: 'English'
    },

    index: {
        time: 'Beijing time',
        languages: 'language',
        en: 'english',
        cn: 'chinese',
        tras: 'Trasaction ID',
        block: 'Block Number',

        acco: 'Account Name',
        acti: 'Action Name',
        gmt: 'Timestamp(GMT)',
        zhuce: 'subscribe for eos',
        for: 'For developers ',
        re: 'Resource library',
        eosp: 'EOS Public Blockchain',
        news: 'News',
        events: 'Events',
        about: 'About EOSIo',
        // 
        dev: 'Developer Portal',
        stack: 'Stack Exchange',
        cont: 'Contact',
        faq: 'FAQS',
        pri: 'Privacy policy',
        terms: 'Terms of use',
        notic: 'Important notice',
        feed: 'Feedback',
        secur: 'Security',
        numb: 'Number of Actions',
        coll: 'collect by minute',
        jiao: 'Trasaction List',
        cotime: 'collect  time',
        coll5: 'collect by 5 minute'
    }
}



// WEBPACK FOOTER //
// ./src/assets/lang/en.js